// A place to put shared constants

export const LEXICON_URL = "https://lexicon-production.herokuapp.com/update";
